import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emmemployeeApi = createApi({
  reducerPath: 'emmemployeeApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Employee'],

  endpoints: (builder) => ({
    getEmployees: builder.query<(em_memployee & em_mdepartment)[], string>({
      query: (cid) => `employee/${cid}`,
      providesTags: ['Employee']
    }),
    getEmployee: builder.query<em_memployee, string>({
      query: (id) => `employee/byid/${id}`
    }),
    insertEmployee: builder.mutation({
      query: (employee) => ({
        url: `employee/`,
        method: 'POST',
        body: employee
      }),
      invalidatesTags: ['Employee']
    }),
    updateEmployee: builder.mutation({
      query: (employee) => ({
        url: `employee/`,
        method: 'PUT',
        body: employee
      }),
      invalidatesTags: ['Employee']
    }),
    deleteEmployee: builder.mutation({
      query: (employee) => ({
        url: `employee/${employee.em_id}`,
        method: 'DELETE',
        body: employee
      }),
      invalidatesTags: ['Employee']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetEmployeesQuery,
  useGetEmployeeQuery,
  useInsertEmployeeMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation
} = emmemployeeApi;
